import { render, staticRenderFns } from "./StackedAttendeesGroup.vue?vue&type=template&id=15aa9f35"
import script from "./StackedAttendeesGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./StackedAttendeesGroup.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports